import { render, staticRenderFns } from "./AccountCreatedPage.vue?vue&type=template&id=b3dfddec&"
import script from "./AccountCreatedPage.vue?vue&type=script&lang=js&"
export * from "./AccountCreatedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports